// Warehouse routes (under accounting app, separate "warehouse" permission)

// Warehouse requires explicit permission (appadmins bypass). Two apps reach
// these screens: "warehouse" is the full stock job, "warehouse-ops" is the
// kitchen operator who records the day-to-day entries. What each may DO is
// enforced per route on the server; this only decides who sees the pages.
const meta = { requiresAuth: true, app: ["warehouse", "warehouse-ops"] };

const routes = [
  {
    path: "/accounting/warehouse",
    name: "WarehouseInventory",
    component: () => import("@/views/warehouse/WarehouseInventoryView.vue"),
    meta,
  },
  {
    path: "/accounting/warehouse/journal",
    name: "WarehouseJournal",
    component: () => import("@/views/warehouse/WarehouseJournalView.vue"),
    meta,
  },
  {
    path: "/accounting/warehouse/ledger",
    name: "WarehouseLedger",
    component: () => import("@/views/warehouse/WarehouseLedgerView.vue"),
    meta,
  },
  {
    path: "/accounting/warehouse/par-stock",
    name: "WarehouseParStock",
    component: () => import("@/views/warehouse/WarehouseParStockView.vue"),
    meta,
  },
  {
    path: "/accounting/warehouse/monthly-summary",
    name: "WarehouseMonthlySummary",
    component: () => import("@/views/warehouse/WarehouseMonthlySummaryView.vue"),
    meta,
  },
];

export default routes;
